import { AuthConfig, NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable, from, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthSessionService } from './auth-session.service';
import { User } from '../../models/user';
import { Profile } from '../../modules/administration/models/profile';
import { Profiles } from '../../modules/administration/models/profiles';
import { HabilitationService } from '../../modules/administration/services/habilitation.service';
import { SessionService } from '../../modules/administration/services/session.service';
import { LogService } from '../../modules/shared/services/log.service';
import { SsoConfig } from '../../oidc-services/sso.config';

export class OidcSessionService implements AuthSessionService {

  private LOG: LogService = new LogService(OidcSessionService);

  sortedProfilesBySiret : Array<Profile> = [];
  sortedProfBySiretService : Array<Profile> = [];

  public userInfoBs: BehaviorSubject<User> = new BehaviorSubject(new User()); // TODO check use with Houssem
  public accessTokenObject: any;
  constructor(
    private oauthService: OAuthService,
    private session: SessionService,
    private habilitationService: HabilitationService
    ) {  }


    private getIdToken(): string {
      return this.oauthService.getIdToken();
    }

    private getAccessToken(): string {
      return this.oauthService.getAccessToken();
    }

    public setAccessTokenObject(accessToken: any) {
      this.accessTokenObject = accessToken;
    }

    private getOAuthService() {
      return this.oauthService;
    }

    public isReady(): Observable<boolean> {
      // No need to wait for a particular operation for this to be ready
      return of(true)
    }

    public configure(): Observable<void> {
      this.oauthService.configure(this.authCodeFlowConfig());
      this.oauthService.tokenValidationHandler = new NullValidationHandler();

      this.oauthService.setupAutomaticSilentRefresh();

      // se connecter en mode normal
      return from(this.oauthService.loadDiscoveryDocumentAndLogin().then(data => {
        if (data) {
          this.setUserInfo();
        }
      }));
    }

    private authCodeFlowConfig(): AuthConfig {
      return SsoConfig.SSO_CONF;
    }

    public getProfiles(): Observable<Profiles> {
      return this.habilitationService.getProfiles();
    }

    /**
    * Création des headers nécessaires pour une connexion OIDC
    * @returns l'objet header à utiliser
    */
    public getHeaders(): { [name: string]: string } {
      var headers = {};
      const headersMap: Map<string, string> = new Map();

      let authorisationContent = this.getIdToken();
      let accessToken = this.getAccessToken();
      if (accessToken && authorisationContent) {
        if (environment.only_payload === 'true') {
          authorisationContent = authorisationContent.split('.')[1];
        }
        headersMap.set('Authorization', 'Bearer ' + authorisationContent);
        headersMap.set('access_token', accessToken);
      }

      headersMap.set('siret', this.session.getUser()?.siret);
      headersMap.set('service', this.session.getUser()?.service);

      headersMap.forEach((v, k) => {
        if (v) headers = Object.assign(headers, { [k]: v });
      });
      return headers;
    }

    public logOut(): void {
      // Clean up local data without calling log out URL
      // as this is call when the user is *already* disconnected
      this.oauthService.logOut(false);
      // Redirect to post log out URI anyway
      this.oauthService.openUri(this.oauthService.postLogoutRedirectUri);
    }

    public setUserInfo() { // TODO Check use with Houssem
      if (this.isUserInfoPresent()) {
        this.logInfo();
        let id_token_claims_obj = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
        let userInfo: User = new User();
        userInfo.id = id_token_claims_obj.client_id;
        userInfo.mel = id_token_claims_obj.preferred_username;
        this.userInfoBs.next(userInfo);
      }
    }

    private isUserInfoPresent(): boolean {
      return this.oauthService.hasValidAccessToken() && sessionStorage.getItem('id_token_claims_obj') !== undefined;
    }

    isSwitchable(): Observable<boolean> {
      return of(true);
    }

    public logInfo() {
      this.getOAuthService().loadUserProfile().then(data => {
        this.LOG.error('======================[SESSION_INFO_BEGIN]=========================')
        this.LOG.info('[USER_PROFILE]:', data);
        this.LOG.info('[ACCESS_TOKEN_OBJECT]:', this.accessTokenObject);
        this.LOG.info('[ACCESS_TOKEN] :', this.getOAuthService().getAccessToken())
        this.LOG.info('[ACCESS_TOKEN_EXPIRATION][TIME_STAMP] :', this.getOAuthService().getAccessTokenExpiration())
        this.LOG.info('[ACCESS_TOKEN_EXPIRATION][DATE] :', new Date(this.getOAuthService().getAccessTokenExpiration()).toLocaleString())
        this.LOG.info('[ID_TOKEN] :', this.getOAuthService().getIdToken())
        this.LOG.info('[ACCESS_TOKEN_EXPIRATION][TIME_STAMP]:', this.getOAuthService().getAccessTokenExpiration())
        this.LOG.info('[ID_TOKEN_EXPIRATION][TIME_STAMP]:', this.getOAuthService().getIdTokenExpiration())
        this.LOG.info('[ACCESS_TOKEN_EXPIRATION][DATE]:', new Date(this.getOAuthService().getAccessTokenExpiration()).toLocaleString())
        this.LOG.info('[ID_TOKEN_EXPIRATION][DATE]:', new Date(this.getOAuthService().getIdTokenExpiration()).toLocaleString())
        this.LOG.info('[CLIENT_ID]:', this.getOAuthService().clientId)
        this.LOG.error('======================[SESSION_INFO_END]=========================')
      });
    }
}
